import React from "react";
import PropTypes from "prop-types";
import Skeleton from "react-loading-skeleton";

import { MyDraggable as Draggable } from "../components/Core";
import HoverBar from "../components/HoverBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import { generateStyle, l, setOverLay } from "../functions";
import Icon from "../components/Icons";

import { connect } from "react-redux";

const mapStateToProps = (state) => {
  return {
    currentLang: state.rootReducer.currentLang || 1,
    settings: state.rootReducer?.appearanceSettings || {},
  };
};

class List extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  _initList = (preview) => {
    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;

    const { listItems, iconClass, useIcon, iconPosition, showInline } =
      payload.datas || {};

    const cssSettings = generateStyle(payload, "container");
    const cssSettingsText = generateStyle(payload, "text", "body");
    const cssAlignment = generateStyle(payload, "alignment");

    if (showInline) {
      cssSettingsText.display = "inline-block";
      cssSettingsText.marginRight = 20;
    }

    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className="fullcol">
            {(Array.isArray(listItems) && listItems.length > 0 && (
              <ul className="list-item" style={cssAlignment}>
                {listItems.map((item, index) => (
                  <li key={index} style={cssSettingsText}>
                    {useIcon &&
                      iconPosition !== "right" &&
                      iconClass &&
                      !Array.isArray(iconClass) && (
                        <span style={{ marginRight: 5 }} className="left">
                          <FontAwesomeIcon
                            icon={["fas", iconClass.replace("fa-", "")]}
                          />
                        </span>
                      )}
                    {useIcon &&
                      iconPosition !== "right" &&
                      iconClass &&
                      Array.isArray(iconClass) && (
                        <span style={{ marginRight: 5 }} className="left">
                          <FontAwesomeIcon
                            icon={[iconClass[0], iconClass[1]]}
                          />
                        </span>
                      )}

                    {item.data &&
                      item.data.useFAIcon &&
                      item.data.iconFAClass &&
                      !Array.isArray(item.data.iconFAClass) && (
                        <FontAwesomeIcon
                          icon={[
                            "fas",
                            item.data.iconFAClass.replace("fa-", ""),
                          ]}
                        />
                      )}
                    {item.data &&
                      item.data.useFAIcon &&
                      item.data.iconFAClass &&
                      Array.isArray(item.data.iconFAClass) && (
                        <FontAwesomeIcon
                          icon={[
                            item.data.iconFAClass[0],
                            item.data.iconFAClass[1],
                          ]}
                        />
                      )}
                    {item.data && item.data["title_" + this.props.currentLang]}

                    {useIcon &&
                      iconPosition === "right" &&
                      iconClass &&
                      !Array.isArray(iconClass) && (
                        <span style={{ marginLeft: 5 }} className="right">
                          <FontAwesomeIcon
                            icon={["fas", iconClass.replace("fa-", "")]}
                          />
                        </span>
                      )}
                    {useIcon &&
                      iconPosition === "right" &&
                      iconClass &&
                      Array.isArray(iconClass) && (
                        <span style={{ marginLeft: 5 }} className="right">
                          <FontAwesomeIcon
                            icon={[iconClass[0], iconClass[1]]}
                          />
                        </span>
                      )}
                  </li>
                ))}
              </ul>
            )) ||
              (!preview && (
                <ul className="list-item" style={cssAlignment}>
                  <li style={cssSettingsText}>
                    <span style={{ marginRight: 2, display: "inline-block" }}>
                      <Skeleton circle={true} width={10} height={10} />
                    </span>
                    <span style={{ display: "inline-block" }}>
                      <Skeleton width={70} height={10} />
                    </span>
                  </li>
                  <li style={cssSettingsText}>
                    <span style={{ marginRight: 2, display: "inline-block" }}>
                      <Skeleton circle={true} width={10} height={10} />
                    </span>
                    <span style={{ display: "inline-block" }}>
                      <Skeleton width={70} height={10} />
                    </span>
                  </li>
                  <li style={cssSettingsText}>
                    <span style={{ marginRight: 2, display: "inline-block" }}>
                      <Skeleton circle={true} width={10} height={10} />
                    </span>
                    <span style={{ display: "inline-block" }}>
                      <Skeleton width={70} height={10} />
                    </span>
                  </li>
                </ul>
              ))}
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initList(true)}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initList()}
      </Draggable>
    );
  }
}

List.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(List);
